import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFeatureFlags } from '../../contexts/FeatureFlagContext';
import { theme } from '../../theme';

interface Nudge {
  emoji: string;
  title: string;
  description: string;
  cta: string;
  href: string;
}

const BASE_NUDGES: Nudge[] = [
  {
    emoji: '👥',
    title: 'Invitá a tus amigos',
    description: 'Compartí Futbolero y armá tu primer equipo más rápido.',
    cta: 'Invitar amigos',
    href: '/profile',
  },
  {
    emoji: '🏆',
    title: 'Sumate o creá un grupo',
    description: 'Los grupos te muestran los próximos partidos de tu gente.',
    cta: 'Ver grupos',
    href: '/groups',
  },
];

const DISCOVER_NUDGE: Nudge = {
  emoji: '🔎',
  title: 'Buscá partidos cerca tuyo',
  description: 'Descubrí partidos públicos en tu zona y postulate.',
  cta: 'Buscar partidos',
  href: '/discover',
};

export default function NewUserDiscoveryCard() {
  const navigate = useNavigate();
  const flags = useFeatureFlags() as Record<string, any>;
  const NUDGES: Nudge[] = Boolean(flags.PUBLIC_MATCH_DISCOVER)
    ? [...BASE_NUDGES, DISCOVER_NUDGE]
    : BASE_NUDGES;

  return (
    <div
      style={{
        marginTop: theme.spacing.md,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: theme.spacing.sm,
      }}
    >
      {NUDGES.map((nudge) => (
        <div
          key={nudge.href}
          style={{
            backgroundColor: theme.colors.surface,
            border: `1px solid ${theme.colors.border}`,
            borderRadius: theme.borderRadius.card,
            padding: theme.spacing.md,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <div style={{ fontSize: 32 }}>{nudge.emoji}</div>
          <div>
            <h4
              style={{
                margin: 0,
                color: theme.colors.text,
                fontFamily: theme.fonts.body,
                fontSize: '1rem',
                fontWeight: 700,
              }}
            >
              {nudge.title}
            </h4>
            <p
              style={{
                margin: '4px 0 0',
                color: theme.colors.textSecondary,
                fontSize: theme.fonts.sizeSmall,
              }}
            >
              {nudge.description}
            </p>
          </div>
          <button
            type="button"
            onClick={() => navigate(nudge.href)}
            style={{
              alignSelf: 'flex-start',
              padding: `${theme.spacing.xs} ${theme.spacing.md}`,
              backgroundColor: theme.colors.primary,
              color: theme.colors.background,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontWeight: 700,
              fontSize: theme.fonts.sizeSmall,
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: theme.fonts.letterSpacingWide,
            }}
          >
            {nudge.cta}
          </button>
        </div>
      ))}
    </div>
  );
}
